module.exports = __webpack_public_path__ + "static/media/HCMM243.6a973093.jpg";